import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    success: Boolean,
    message: String,
  };

  declare successValue: boolean;
  declare messageValue: string;

  connect() {
    // Close modal
    const modal = document.getElementById("invoice_request_modal") as HTMLDialogElement;
    modal?.close();

    // Show toast
    const type = this.successValue ? "success" : "error";
    window.toast?.(this.messageValue, { type });

    // Clean up
    this.element.remove();
  }
}
